import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {HttpClient} from "@angular/common/http";
import {Observable, Subject} from "rxjs";
import {v4 as uuidv4} from "uuid";
import * as CryptoJS from "crypto-js";

@Injectable({
  providedIn: 'root'
})
export class CartService {

  baseUrl: string;
  productChangeDetection = new Subject<any>();

  constructor(
    private http: HttpClient
  ) {
    this.baseUrl = `${environment.apiEndPoint}/Product/Cart`;
  }

  getCart(sessionId: string): Observable<object> {
    let url = `${this.baseUrl}/GetAllCart`;
    if (sessionId != '') {
      url += '?SessionId=' + sessionId;
    }
    return this.http.get(url);
  }

  addToCart(data: any): Observable<object> {
    if(data.channelId == 2) {
      data.priceId = 0;
    }
    if(data.specProductDetails) {
      data.specsProductId = data.specProductDetails.specProductId
    }
    return this.http.post(`${this.baseUrl}/CreateCart`, data);
  }

  emptyCart(cartId: any): Observable<object> {
    return this.http.get(`${this.baseUrl}/DeleteCart/${cartId}`);
  }

  removeItemFromCart(productId: number): Observable<object> {
    return this.http.get(`${this.baseUrl}/cart/remove-item/${productId}`);
  }

  updateCart(data: any): Observable<object> {
    if(data.specProductDetails) {
      data.specsProductId = data.specProductDetails.specProductId
    }
    return this.http.post(`${this.baseUrl}/UpdateCart`, data);
  }

  productChangeDetect(product: any) {
    this.productChangeDetection.next(product);
  }
}

export class GuidGenerator {
  static newGuid() {
    return uuidv4()
  }
}
